import ProductConfirmController from "./product_confirm_controller"

// Doc: _docs/features/products/partner_products_archived.md
export default class extends ProductConfirmController {
  get errorMessage() {
    return "No se pudo restaurar el producto. Inténtalo de nuevo."
  }
}
